"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const LinkedLayers = props => _react.default.createElement("svg", (0, _extends2.default)({
  width: 20,
  height: 18,
  viewBox: "0 0 20 18"
}, props), _react.default.createElement("path", {
  d: "M16.029 11.792l.091.088.05.055a.634.634 0 01-.89.89l-.056-.05a1.268 1.268 0 00-1.723-.064l-.07.065-1.792 1.793a1.268 1.268 0 001.723 1.857l.07-.065.896-.896a.634.634 0 01.945.84l-.049.056-.896.896a2.535 2.535 0 01-3.673-3.493l.088-.092 1.792-1.792c.96-.96 2.499-.99 3.494-.088zM2.699 11.5l1.544.858L3.09 13l4.91 2.728v1.716L.787 13.437a.5.5 0 010-.874L2.698 11.5zm16.558-2.757c.96.96.99 2.498.088 3.493l-.088.092-1.792 1.792c-.96.96-2.499.99-3.494.088l-.091-.088-.05-.055a.634.634 0 01.89-.89l.056.05a1.268 1.268 0 001.723.064l.07-.065 1.792-1.793a1.268 1.268 0 00-1.723-1.857l-.07.065-.896.896a.634.634 0 01-.945-.84l.049-.056.896-.896c.99-.99 2.595-.99 3.585 0zM2.698 7.5l1.545.858L3.09 9l4.91 2.728v1.716L.787 9.437a.5.5 0 010-.874L2.698 7.5zM9.486.27l7.727 4.293a.5.5 0 010 .874L9.486 9.73a1 1 0 01-.972 0L.787 5.437a.5.5 0 010-.874L8.514.27a1 1 0 01.972 0zm-.487 1.446L3.09 5l5.91 3.284L14.91 5 9 1.716z",
  fill: "#ACB3BE",
  fillRule: "nonzero",
  className: "fill"
}));

var _default = LinkedLayers;
exports.default = _default;